// src/api/client.js
import axios from 'axios';

const apiClient = axios.create({
  baseURL: '/api', // ← pasa por Apache
  withCredentials: false,
  headers: { Accept: 'application/json' },
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem('authToken');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export default apiClient;